import React from 'react'
import dayjs from 'dayjs'
import { Value } from '../elements'
import { Enums } from './interfaces'

const getCardTitle = (cardType: string, cardId: number) => {
  const titles = {
    case: 'Заказ',
    measurement: 'Замер',
    montage: 'Монтаж',
    hr: 'Запись',
    claim: 'Рекламация',
    claim_request: 'Заявка на рекламацию',
    claim_work: 'Работа по рекламации',
    delivery: 'Доставка',
  }
  return `${titles[cardType] || cardType} № ${cardId}`
}

export const getMobileFields = (enums?: Enums) => [
  {
    key: 'card_type',
    label: '',
    render: (val, record) => <strong>{getCardTitle(record.card_type, record.card_id)}</strong>,
  },
  {
    key: 'stage',
    label: 'Стадия задачи',
    render: (val) => {
      if (!val || !enums?.stages) return <Value data={val} />
      const stageLabel = enums.stages.find(i => i.value === val)?.label
      return stageLabel || val
    },
  },
  {
    key: 'deadline',
    label: 'Плановая дата',
    render: (val) => (val ? dayjs(val).format('DD.MM.YYYY HH:mm') : <Value data={val} />),
  },
  {
    key: 'task_type',
    label: 'Тип',
    render: (val) => {
      if (!val || !enums?.task_type) return <Value data={val} />
      const taskTypeLabel = enums.task_type.find(i => i.value === val)?.label
      return taskTypeLabel || val
    },
  },
  {
    key: 'task',
    label: 'Комментарий',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'responsible',
    label: 'Ответственные',
    render: (val: null | string[]) => {
      if (!val) return <Value data={val} />
      return val.join(', ')
    },
  },
]

